import { useState } from "react";

import RCAProprietar from "@containers/RCA/RCAProprietar";
import RCAVehicul from "@containers/RCA/RCAVehicul";
import RCADataPolita from "@containers/RCA/RCADataPolita";
import RcaOffers from "@containers/RCA/RcaOffers";
import Alert from "@components/Alert";

const FormComponentMap = {
  2: RCAProprietar,
  3: RCAVehicul,
  4: RCADataPolita,
  5: RcaOffers,
};

const RCAForm = ({
  currentStep,
  onStepChange,
  apiData,
  onApiDataUpdate,
  onLoadingStateChange,
  isFetching,
}) => {
  const [formData, setFormData] = useState({
    startDate: null,
    vehicle:
      apiData.selectedVehicle && apiData.savedVehicles[apiData.selectedVehicle]
        ? apiData.savedVehicles[apiData.selectedVehicle]
        : {},
  });
  const [errors, setErrors] = useState([]);

  const handleFormDataUpdate = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const handleErrorsUpdate = (error) => {
    setErrors((prevState) => [...prevState, ...error]);
  };

  const FormComponent = FormComponentMap[currentStep];

  return (
    <div className="relative">
      {errors.length > 0 ? (
        <>
          {errors.map((error, index) => (
            <div key={index} className="space-y-[20px] bg-[white] p-[20px]">
              <Alert variant={error.variant} message={error}>
                {error.error}
              </Alert>
            </div>
          ))}
        </>
      ) : (
        <FormComponent
          apiData={apiData}
          formData={formData}
          onFormDataUpdate={handleFormDataUpdate}
          onApiDataUpdate={onApiDataUpdate}
          onStepChange={onStepChange}
          onLoadingStateChange={onLoadingStateChange}
          isFetching={isFetching}
          onErrorsUpdate={handleErrorsUpdate}
        />
      )}
    </div>
  );
};

export default RCAForm;
